<template>
    <div>
        <v-list-item class="text-card-line pa-0">
            <v-list-item-content class="text-center">
                <v-list-item-title
                    v-if="title"
                    :class="classText"
                    v-text="title"
                ></v-list-item-title>
                <template v-for="(subtitle, index) in subtitles">
                    <v-list-item-subtitle :key="index" :class="classSubtitle" style="margin-left: 5px">
                        <template v-if="subtitle.increment == true">
                            <animated-number
                                v-if="subtitle.currency == false"
                                :value="subtitle.value"
                                :formatValue="formatToNumber"
                                :duration="1000"
                                round="1"
                            />
                            <animated-number
                                v-else
                                :value="subtitle.value"
                                :formatValue="formatToPrice"
                                :duration="1000"
                                round="1"
                            />
                        </template>
                        <template v-else-if="subtitle.show == null">
                            <b>{{ subtitle.key }}</b> {{ subtitle.value }}
                        </template>
                    </v-list-item-subtitle>
                </template>
            </v-list-item-content>
        </v-list-item>
    </div>
</template>

<script>
import AnimatedNumber from "animated-number-vue";

export default {
    components: {
        AnimatedNumber
    },
    data() {
        return {
            value: 0
        };
    },

    props: ["title", "subtitles", "classText", "classSubtitle"],

    methods: {
        formatToNumber(subtitle) {
            return `<div class="display-1"><span>${subtitle}</span></div>`;
        },
        formatToPrice(subtitle) {
            return `<div class="display-1"><span>R$${Number(subtitle)
                    .toFixed(2)
                    .replace(".", ",")}</span></div>`;
        }
    }
};
</script>

<style lang="scss">
.v-list-item--dense {
    &.text-card-line {
        min-height: initial;
    }
}
</style>
